var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDish = function SvgDish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F3354",
    d: "M.75 15.35v-1.347h16.5v1.347zm.778-2.418v-.552q0-2.76 1.746-4.827Q5.02 5.487 7.681 5.007v-.31q0-.552.39-.95T9 3.35q.54 0 .929.398.39.397.39.948v.311q2.674.48 4.414 2.546t1.74 4.827v.552zm1.37-1.346h12.203q-.257-2.265-2.01-3.818T9 6.216 4.916 7.768t-2.017 3.818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M.75 15.35v-1.347h16.5v1.347zm.778-2.418v-.552q0-2.76 1.746-4.827Q5.02 5.487 7.681 5.007v-.31q0-.552.39-.95T9 3.35q.54 0 .929.398.39.397.39.948v.311q2.674.48 4.414 2.546t1.74 4.827v.552zm1.37-1.346h12.203q-.257-2.265-2.01-3.818T9 6.216 4.916 7.768t-2.017 3.818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M.75 15.35v-1.347h16.5v1.347zm.778-2.418v-.552q0-2.76 1.746-4.827Q5.02 5.487 7.681 5.007v-.31q0-.552.39-.95T9 3.35q.54 0 .929.398.39.397.39.948v.311q2.674.48 4.414 2.546t1.74 4.827v.552zm1.37-1.346h12.203q-.257-2.265-2.01-3.818T9 6.216 4.916 7.768t-2.017 3.818"
  })));
};
export default SvgDish;